module.exports = __webpack_public_path__ + "img/ic24Address.36ceb03b.svg";